import script from "./view-image.vue?vue&type=script&setup=true&lang=ts"
export * from "./view-image.vue?vue&type=script&setup=true&lang=ts"

import "./view-image.vue?vue&type=style&index=0&id=4ace0ad1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ace0ad1"]])

export default __exports__